import { createReactOidc } from 'oidc-spa/react'
import { getBrandConfig } from '@/config/config'

const config = getBrandConfig()

export type DecodedIdToken = {
  sub: string
  aud: string
  exp: number
  family_name: string
  given_name: string
  name: string
  /**
   * Pam Account ID
   */
  'pam-aid': string
  /**
   * Pam Account Type
   */
  'pam-atype': 'STAFF' | 'PLAYER'
  preferred_username: string
  /**
   * Encoded Account Capabilities,
   * Use {@link decodeCapabilities} to get real values
   */
  'pam-cid': string
}

let oidc: ReturnType<typeof createReactOidc<DecodedIdToken>> | undefined =
  undefined

if (import.meta.hot) {
  oidc = import.meta.hot.data.oidc
}

oidc =
  oidc ||
  createReactOidc<DecodedIdToken>({
    issuerUri: `${config.keycloak.url}/${config.keycloak.realm}/`,
    clientId: config.keycloak.clientId,
    homeUrl: import.meta.env.BASE_URL || '/',
    scopes: [], // "profile" is added by default, we don't want it because it has PII info so we override scopes"
  })

if (import.meta.hot) {
  import.meta.hot.data.oidc = oidc
}

export const { getOidc, useOidc, OidcProvider } = oidc
